<template>
  <v-text-field
    v-model="localValue"
    outlined
    dense
    :hint="localValue ? '' : validReproMessage"
    label="Reproduction Link"
    :error-count="2"
    persistent-hint
    :rules="[rules.requiredText, localRules.validRepro]"
  >
    <template #message="{ message }">
      <div v-html="message" />
    </template>
  </v-text-field>
</template>

<script>
  import major from 'semver/functions/major'
  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'

  export default {
    name: 'FormLinkField',
    mixins: [StringValue, RequiredRules],
    props: {
      repo: { type: Object, default: () => ({}) },
      version: { type: String, default: '' },
    },
    data () {
      return {
        localRules: {
          validRepro: (v) => {
            if (String(v).startsWith('https://codepen.io/pen')) {
              return 'Please save your codepen first'
            }
            if (this.isDocs && !/^https?:\/\/.*(vuetifyjs)/.test(v)) {
              return this.validReproMessage
            }
            if (!this.isDocs && !/^https?:\/\/.*(github|codepen|jsfiddle|codesandbox|stackblitz|play\.vuetifyjs)/.test(v)) {
              return this.validReproMessage
            }
            if (/^https?:\/\/github.com\/vuetifyjs\/?/.test(v)) {
              return this.validReproMessage
            }
            return true
          },
        },
      }
    },
    computed: {
      isDocs () {
        return this.repo.value === 'docs'
      },
      errorMessages () {
        return [this.rules.requiredText, this.localRules.validRepro].map(rule => rule(this.localValue))
      },
      validReproMessage () {
        return this.isDocs
          ? 'Please provide a link to the relevant documentation page.'
          : this.version && major(this.version) === 2
            ? 'Please only use <a href="https://template.vuetifyjs.com" rel="noopener" target="_blank" tabindex="-1">Codepen</a>, <a href="https://www.jsfiddle.net" rel="noopener" target="_blank" tabindex="-1">JSFiddle</a>, <a href="https://codesandbox.io/s/vue" target="_blank" rel="noopener" tabindex="-1">CodeSandbox</a> or a GitHub repository.'
            : 'Please only use <a href="https://play.vuetifyjs.com" rel="noopener" target="_blank" tabindex="-1">Playground</a> or a github repo.'
      },
    },
  }
</script>
